var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TimeConstraintList',{attrs:{"constrainedItem":_vm.currentClock && _vm.currentClock,"timeConstraintType":_vm.timeConstraintType,"allowDateSelection":false,"allowDayOfWeekSelection":false,"allowDayOfMonthSelection":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }